import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { MssFieldBaseFieldTypeComponent } from '@shared/components/formly/fields/mss-field-base.component';
import { MSS_FORMLY_IMPORTS } from '@shared/components/formly/formly-standalone-imports';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

@Component({
  templateUrl: 'currency.component.html',
  imports: [
    NgClass,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskDirective,
    ...MSS_FORMLY_IMPORTS,
  ],
  providers: [provideNgxMask({ thousandSeparator: ',' })],
})
export class CurrencyFieldTypeComponent extends MssFieldBaseFieldTypeComponent {
  public static readonly defaultOptions: FormlyFieldConfig = {
    props: {
      addonStart: '£',
      min: 0,
      ...MssFieldBaseFieldTypeComponent.focusBlurZeroDefault,
    },
  };
}
